import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import "intro.js/introjs.css";
import IntroJS from "intro.js";
import IntroCloseicon from "../../assets/images/introCloseIcon.png";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import db from "../../database";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const location = useLocation();
  const [showTillModal, setShowTillModal] = useState(false);

  // Register service worker
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/worker.js")
          .then(() => {})
          .catch(() => {});
      });
    }
  }, []);

  const productTourSteps = localStorage.getItem("productTourSteps");
  const existingUser = localStorage.getItem("existingUser");

  useEffect(() => {
    const pageKey = `intro-tour-${window.location.hash}`;
    const hasCompletedTour = localStorage.getItem(pageKey);
    if (!hasCompletedTour && (existingUser === null || existingUser === "undefined")) {
      const jsonArray = JSON.parse(JSON.parse(productTourSteps));
      let currentPageSteps = [];
      if (jsonArray && Array.isArray(jsonArray)) {
        jsonArray.forEach((data) => {
          data.data.forEach((stepsData) => {
            if (stepsData.page === window.location.hash || stepsData.page + "/" === window.location.hash) {
              currentPageSteps = stepsData.steps;
            }
          });
        });
      }

      let phoneImg = document.createElement("img");
      phoneImg.src = IntroCloseicon;
      phoneImg.alt = "Skip tour";

      let intro = IntroJS().setOptions({
        steps: currentPageSteps,
        nextButton: "my-next-button",
        prevButton: "my-prev-button",
        skipLabel: phoneImg.outerHTML,
      });

      intro.oncomplete(() => {
        localStorage.setItem(pageKey, "completed");
      });

      setTimeout(() => {
        intro.start();
      }, 2000);
    }
  }, [location]);

  // ✅ Auth check logic
  const authHeaders = getOAuthHeaders();
  const cleanToken = authHeaders?.access_token;
  const email = authHeaders?.email;
  const username = authHeaders?.username;

  const isAuthenticated = cleanToken !== "bearer undefined" && (email || username);

  return (
    <>
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Component {...props} {...rest} />
          ) : (
            <Redirect
              to={{
                pathname: "/sign-in",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    </>
  );
};

export default PrivateRoute;
